import { observable, action } from 'mobx'

class StaffListModel {
    @observable
    public staffNum: number = 0

    @observable
    public maxStaffNum: number = 0

    @observable
    public isUpdateApplyNum = false

    @action
    public setStaffNum(num: number) {
        this.staffNum = num
    }

    @action
    public setMaxStaffNum(num: number) {
        this.maxStaffNum = num
    }

    @action
    public setUpdateApplyNum() {
        this.isUpdateApplyNum = !this.isUpdateApplyNum
    }
}

export const staffListModel = new StaffListModel()
